import helper from '../utils/helper';

export class GridDataAdapter {
    static transform(data, fields) {
        const transformedData = {};

        if (data?.id) {
            transformedData.id = data.id;
        }

        const fieldProcessors = {
            boolean: (field) => {
                return data?.[field.id] !== null &&
                    data?.[field.id] !== undefined
                    ? data?.[field.id]
                    : field.defaultValue;
            },
            object: (field) => {
                if (field.cell === 'Upload') {
                    return helper.transformUploadFile(data?.[field.object]);
                }
                return data?.[field.object]?.id || null;
            },
            merchantUpload: (field) =>
                helper.transformUploadFiles(data?.[field.id] || []),
            owner: (field) => {
                const kind = data?.[data.kind];
                return kind?.id || null;
            },
            walletArray: (field) => {
                return (
                    data?.[field.id]?.map((wallet) => wallet.walletNumber) || []
                );
            },
            amount: (field) => {
                let value;
                if (field.object && field.display) {
                    // Handle nested objects like wallet.currentBalance
                    value = data?.[field.object]?.[field.display];
                } else {
                    // Handle direct properties
                    value = data?.[field.id];
                }
                if (value !== null && value !== undefined && value !== '') {
                    const num = parseFloat(value);
                    return isNaN(num) ? 0 : num;
                }
                return field.defaultValue || 0;
            },
            default: (field) => {
                return field.defaultValue || data?.[field.id] || null;
            }
        };

        fields.forEach((field) => {
            const processor =
                fieldProcessors[field.type] ||
                (field.object
                    ? fieldProcessors['object']
                    : fieldProcessors['default']);
            transformedData[field.id] = processor(field);
        });

        return transformedData;
    }
}
